<template>
  <div>
    <PageHeaderBanner>
      <template #title>
        <span v-if="mode === modeType.MODE_REGISTER">お知らせ新規登録</span>
        <span v-if="mode === modeType.MODE_EDIT">お知らせ情報変更</span>
      </template>
    </PageHeaderBanner>
    <MessageChip :display="isMessageChip" level="E" :message="errMessage" />
    <q-form autofocus greedy @submit.prevent="submit" @reset="reset" @validation-error="resetError">
      <div class="cmd01010-input-form q-gutter-y-md">
        <div class="row items-center q-gutter-x-md">
          <div class="col-2.5">
            <label class="requier">公開開始日時</label>
            <div class="row q-gutter-x-xs">
              <q-input
                v-model="inputData.start_date"
                outlined
                dense
                class="date q-pb-none"
                readonly
                style="background: var(--q-white); width: 164px"
                clearable
                :rules="[(val) => isEmpty(val) || $t('validation.required')]"
                lazy-rules
              >
                <template #append>
                  <q-icon name="event" class="cursor-pointer"></q-icon>
                </template>
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="inputData.start_date" minimal mask="YYYY/MM/DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="OK" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-input>
              <q-input
                v-model="inputData.start_time"
                outlined
                dense
                class="date q-pb-none"
                readonly
                style="background: var(--q-white); width: 120px"
                clearable
                :rules="[(val) => isEmpty(val) || $t('validation.required')]"
                lazy-rules
              >
                <template #append>
                  <q-icon name="access_time" class="cursor-pointer"></q-icon>
                </template>
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-time v-model="inputData.start_time" mask="HH:mm" :format24h="false">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="OK" color="primary" flat />
                    </div>
                  </q-time>
                </q-popup-proxy>
              </q-input>
            </div>
          </div>
          <div class="col-2.5">
            <label class="requier">公開終了日時</label>
            <div class="row q-gutter-x-xs">
              <q-input
                v-model="inputData.end_date"
                outlined
                dense
                class="date q-pb-none"
                readonly
                style="background: var(--q-white); width: 164px"
                clearable
                :rules="[(val) => isEmpty(val) || $t('validation.required')]"
                lazy-rules
              >
                <template #append>
                  <q-icon name="event" class="cursor-pointer"></q-icon>
                </template>
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-date v-model="inputData.end_date" minimal mask="YYYY/MM/DD">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="OK" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-input>
              <q-input
                v-model="inputData.end_time"
                outlined
                dense
                class="date q-pb-none"
                readonly
                style="background: var(--q-white); width: 120px"
                clearable
                :rules="[(val) => isEmpty(val) || $t('validation.required')]"
                lazy-rules
              >
                <template #append>
                  <q-icon name="access_time" class="cursor-pointer"></q-icon>
                </template>
                <q-popup-proxy cover transition-show="scale" transition-hide="scale">
                  <q-time v-model="inputData.end_time" mask="HH:mm" :format24h="false">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="OK" color="primary" flat />
                    </div>
                  </q-time>
                </q-popup-proxy>
              </q-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="requier">件名</label>
            <q-input
              v-model="inputData.news_title"
              outlined
              dense
              :maxlength="100"
              class="input-area"
              counter
              :rules="[(val) => isEmpty(val) || $t('validation.required')]"
              lazy-rules
              @keydown.enter.prevent
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label class="requier">本文</label>
            <q-input
              v-model="inputData.news_body"
              outlined
              dense
              type="textarea"
              rows="7"
              :maxlength="1000"
              counter
              :rules="[(val) => isEmpty(val) || $t('validation.required')]"
              lazy-rules
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label>表示対象</label>
            <div class="q-gutter-sm">
              <q-checkbox
                v-model="inputData.browseable_from_login_page"
                label="ログインページ"
                color="primary"
              />
              <q-checkbox
                v-model="inputData.browseable_from_top_page"
                label="トップページ"
                color="primary"
              />
            </div>
          </div>
        </div>
        <FormFooterBanner style="position: inherit">
          <template #button-area>
            <div class="row">
              <q-btn
                color="grey-7"
                outline
                label="戻る"
                style="min-width: 120px; background: var(--q-white) !important"
                @click="router.replace({ name: 'news' })"
              />
              <div class="col q-gutter-x-xs flex justify-end">
                <q-btn
                  type="submit"
                  color="primary"
                  style="width: 150px"
                  :label="mode === modeType.MODE_REGISTER ? '登録' : '変更'"
                />
                <q-btn
                  type="reset"
                  outline
                  style="
                    width: 150px;
                    background: var(--q-white) !important;
                    color: var(--q-delete);
                  "
                  :icon="mode === modeType.MODE_REGISTER ? 'mdi-eraser' : 'cached'"
                  :label="mode === modeType.MODE_REGISTER ? 'クリア' : 'リセット'"
                />
              </div>
            </div>
          </template>
        </FormFooterBanner>
      </div>
    </q-form>
    <AlertDialog
      :display="dialogDisplayFlg"
      :level="DIALOG_LEVEL"
      :confirmation="dialogConfFlg"
      :title="dialogTitle"
      :text="dialogText"
      @complete="router.replace({ name: 'news' })"
      @confirm="mode === modeType.MODE_REGISTER ? registerNews() : editNews()"
      @close="dialogDisplayFlg = false"
    />
  </div>
</template>
<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Loading } from 'quasar';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import axios from '../../common/axios-common';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import MessageChip from '../../components/chip/MessageChip.vue';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import { isEmpty } from '../../common/utils/validateUtils';
import messages from '../../messages/message.json';

interface Props {
  mode: string;
  newsId?: string;
}

const router = useRouter();
const now = new Date();
// お知らせ一覧画面からの遷移時に取得した値(mode, newsId)
const props = defineProps<Props>();
// お知らせ一覧画面で取得したお知らせID
const news_id = ref(props.newsId ? props.newsId : '');
// ダイアログのdisplayFlg(表示判断)
const dialogDisplayFlg = ref(false);
// ダイアログのlevel(informationで固定)
const DIALOG_LEVEL = 'information';
// ダイアログのtitle
const dialogTitle = ref('');
// ダイアログのtext(配列にすることでXSSの対策を行う)
const dialogText = ref(['']);
// ダイアログのconfirmation(trueならキャンセルボタンを表示しない)
const dialogConfFlg = ref(false);
// 日付入力チェックのための公開開始日時
const publish_datetime = ref<Date>();
// 日付入力チェックのための公開終了日時
const publication_period = ref<Date>();
// エラーメッセージ表示フラグ
const isMessageChip = ref(false);
// エラーメッセージ
const errMessage = ref('');

const modeType = {
  // 登録
  MODE_REGISTER: '0',
  // 編集
  MODE_EDIT: '1',
};

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * システム日付を取得
 */
const getDate = () => {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const date = now.getDate();

  const mo = ref('');
  if (month < 10) {
    mo.value = `0${month.toString()}`;
  } else {
    mo.value = `${month.toString()}`;
  }

  const da = ref('');
  if (date < 10) {
    da.value = `0${date.toString()}`;
  } else {
    da.value = `${date.toString()}`;
  }

  return `${year}/${mo.value}/${da.value}`;
};

/**
 * システム時刻を取得
 */
const getTime = () => {
  const hour = now.getHours();
  const minute = now.getMinutes();

  const ho = ref('');
  if (hour < 10) {
    ho.value = `0${hour.toString()}`;
  } else {
    ho.value = `${hour.toString()}`;
  }

  const mi = ref('');
  if (minute < 10) {
    mi.value = `0${minute.toString()}`;
  } else {
    mi.value = `${minute.toString()}`;
  }

  return `${ho.value}:${mi.value}`;
};

// リセット用データ
const resetData = reactive({
  // publish_datetimeの日付部分
  start_date: getDate(),
  // publish_datetimeの時刻部分
  start_time: getTime(),
  // publication_periodの日付部分
  end_date: '',
  // publication_periodの時刻部分
  end_time: '',
  news_title: '',
  news_body: '',
  browseable_from_login_page: true,
  browseable_from_top_page: true,
});

// 入力データ
const inputData = ref({ ...resetData });

/**
 * エラー初期化
 */
const resetErrors = () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * ダイアログの中身を設定
 */
const submit = () => {
  resetErrors();
  publish_datetime.value = new Date(`${inputData.value.start_date} ${inputData.value.start_time}`);
  publication_period.value = new Date(`${inputData.value.end_date} ${inputData.value.end_time}`);

  if (publish_datetime.value >= publication_period.value) {
    errMessage.value = messages.ja.message.MSG_50071E;
    isMessageChip.value = true;
  } else if (props.mode === modeType.MODE_REGISTER) {
    dialogTitle.value = '登録確認';
    dialogText.value = ['入力された内容で登録します。', 'よろしいですか？'];
    dialogDisplayFlg.value = true;
  } else {
    dialogTitle.value = '更新確認';
    dialogText.value = ['入力された内容で更新します。', 'よろしいですか？'];
    dialogDisplayFlg.value = true;
  }
};

/**
 * クリア、リセット
 */
const reset = () => {
  inputData.value = { ...resetData };
  resetErrors();
  if (props.mode === modeType.MODE_REGISTER) {
    // クリアをかけたら公開開始日時を空欄にする
    inputData.value.start_date = '';
    inputData.value.start_time = '';
    // クリアをかけたらチェックボックスをチェックoffにする
    inputData.value.browseable_from_login_page = false;
    inputData.value.browseable_from_top_page = false;
  }
};

/**
 * お知らせ情報取得処理(更新画面の初期表示用)
 */
const getNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();
  const formData = new FormData();
  formData.append('news_id', news_id.value);

  // お知らせ情報を取得するController呼び出し
  await axios
    .post('/cmd010102/getNews', formData)
    .then((res) => {
      const { common, newsData } = res.data;

      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          Object.assign(resetData, newsData);
          inputData.value = newsData;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他のエラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * お知らせ登録処理
 */
const registerNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('start_date', inputData.value.start_date);
  formData.append('start_time', inputData.value.start_time);
  formData.append('end_date', inputData.value.end_date);
  formData.append('end_time', inputData.value.end_time);
  formData.append('news_title', inputData.value.news_title);
  formData.append('news_body', inputData.value.news_body);
  formData.append(
    'browseable_from_login_page',
    inputData.value.browseable_from_login_page.toString()
  );
  formData.append('browseable_from_top_page', inputData.value.browseable_from_top_page.toString());

  // お知らせ登録を行うController呼び出し
  await axios
    .post('/cmd010101/register', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 登録確認ダイアログのtitleを設定
          dialogTitle.value = '登録完了';
          // 登録確認ダイアログのtextを生成
          dialogText.value = [`${inputData.value.news_title} の登録が完了しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.INSERT_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 * お知らせ変更処理
 */
const editNews = async () => {
  resetErrors();
  // Loading Start
  Loading.show();

  const formData = new FormData();
  formData.append('news_id', news_id.value);
  formData.append('start_date', inputData.value.start_date);
  formData.append('start_time', inputData.value.start_time);
  formData.append('end_date', inputData.value.end_date);
  formData.append('end_time', inputData.value.end_time);
  formData.append('news_title', inputData.value.news_title);
  formData.append('news_body', inputData.value.news_body);
  formData.append(
    'browseable_from_login_page',
    inputData.value.browseable_from_login_page.toString()
  );
  formData.append('browseable_from_top_page', inputData.value.browseable_from_top_page.toString());

  // お知らせ変更を行うController呼び出し
  await axios
    .post('/cmd010102/edit', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // 変更確認ダイアログのtitleを設定
          dialogTitle.value = '更新完了';
          // 変更確認ダイアログのtextを生成
          dialogText.value = [`${inputData.value.news_title} の更新が完了しました。`];
          // ダイアログのボタン数判断をtrue(1つ)に
          dialogConfFlg.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              errMessage.value = common.message;
              isMessageChip.value = true;
              // ダイアログ表示判断をfalse(非表示)に変更
              dialogDisplayFlg.value = false;
              break;

            // パラメータエラーの場合
            case DetailResultStatusCode.PARAMETER_ERROR:
              router.push({ name: 'error' });
              break;
            default:
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

// propsが存在しない場合
if (!props.mode) {
  // 前画面に遷移
  router.replace({ name: 'news' });
} else if (props.mode === modeType.MODE_EDIT) {
  getNews();
}
</script>
<style scoped>
.cmd01010-input-form {
  width: 70%;
  margin: 0 auto;
}
</style>
<style>
.cmd01010-input-form .q-field--outlined.q-field--readonly .q-field__control:before {
  border-style: solid;
}

.cmd01010-input-form .q-textarea.q-field--dense .q-field__control {
  align-items: center;
}

.cmd01010-input-form .q-textarea .q-field__control {
  padding-right: 3px;
}
</style>
